import AdminLogin from '../../pages/AdminLogin';
import { useAdminUser } from '../hook/AdminUserContext';

const AdminPrivateRoute = ({ Component }) => {
  const { user, loading, isAuthenticated } = useAdminUser();

  if (loading) {
    return <div>Chargement en cours...</div>;
  }

  if (!isAuthenticated || !user) {
    return <AdminLogin />;
  }

  /*  const isAdmin = user.role === 'administrator' || user.role === 'moderator';

  if (!isAdmin) {
    return <Navigate to="/signin" replace />;
  } */

  return <Component />;
};

export default AdminPrivateRoute;
